import Box from "../Box";
import FollowUpMessage, { type FollowUpMessageProps } from "./FollowUpMessage";

export type FollowUpMessageListProps = {
	messages: FollowUpMessageProps[];
};

const FollowUpMessageList = ({ messages }: FollowUpMessageListProps) => {
	return (
		<Box gap={8} flexDirection="column">
			{messages.map((message, index) => (
				<FollowUpMessage
					key={`${message.message}-${index}`}
					message={message.message}
					icon={message.icon}
					onPress={message.onPress}
				/>
			))}
		</Box>
	);
};

export default FollowUpMessageList;
